<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item" @click="switchTab('staff')">STAFF MEMBERS</div>
        <div class="h-spacer"></div>
        <div class="tab-item active" @click="switchTab('customer')">
          CUSTOMER MEMBERS
        </div>
      </div>
      <div class="tab-options">
        <b-select v-model="form_filter.type" placeholder="Search Type">
          <option v-for="option in search_types" :value="option.value" :key="option.value">
            {{ option.name }}
          </option>
        </b-select>
        <div class="h-spacer"></div>
        <b-input placeholder="Search..." type="search" icon-pack="fas" icon="search" custom-class="input-size"
          v-model="form_filter.query" @input="searchUser">
        </b-input>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_users && user_data" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Names</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Date</th>
            </tr>
            <tr v-for="(item, index) in user_data.data" :key="index" @click="selectUser(item)">
              <td>
                <widgetProfile :title="`${item.first_name} ${item.last_name}`" subtitle="" :file_name="item.profile_image"
                  :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'"></widgetProfile>
              </td>
              <td>{{ item.phone }}</td>
              <td>{{ item.email }}</td>
              <td>
                {{ moment(item.created_at).format("MMM DD YYYY HH:mm A") }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="loading_users" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Names</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td>
                <b-skeleton circle width="40px" height="40px"></b-skeleton>
              </td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="selected_staff" class="rigth-panel">
        <b-button
          type="is-danger"
          class="closeProfileButton"
          size="is-small"
          @click="selected_staff = false"
        >Close</b-button>
        <userFullDetails :value="selected_staff" :user="selected_staff" type="member" user_type="HOST">
        </userFullDetails>
      </div>
      <div v-else class="rigth-panel no-data-panel">
        <widgetNotfound title="No User selected" subtitle="Select a user to see  details"></widgetNotfound>
      </div>
    </div>
    <div class="wrapper-footer">
      <b-pagination :total="pagination_options.total" v-model="pagination_options.current" @change="getUserData"
        :range-before="pagination_options.rangeBefore" :range-after="pagination_options.rangeAfter"
        :order="pagination_options.order" :size="pagination_options.size" :simple="pagination_options.isSimple"
        :rounded="pagination_options.isRounded" :per-page="pagination_options.perPage"
        :icon-prev="pagination_options.prevIcon" :icon-next="pagination_options.nextIcon" aria-next-label="Next page"
        aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page"
        :page-input="pagination_options.hasInput" :page-input-position="pagination_options.inputPosition"
        :debounce-page-input="pagination_options.inputDebounce">
      </b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    pagination_options: {
      total: 200,
      current: 1,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      order: "",
      size: "",
      isSimple: false,
      isRounded: false,
      hasInput: false,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      inputPosition: "",
      inputDebounce: "",
    },
    loading_users: true,
    selected_staff: null,
    search_types: [
      { value: "email", name: "Email" },
      { value: "phone", name: "Phone" },
      { value: "names", name: "Names" },
    ],
    form_filter: {
      type: "email",
      page: 1,
      query: "",
    },
    user_data: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getUserData();
  },
  methods: {
    getUserData(page = 1) {
      let vm = this;
      vm.form_filter.page = page;
      vm.loading_users = true;
      vm.$store
        .dispatch("USER_CUSTOMER_GET_ALL", vm.form_filter)
        .then((response) => {
          vm.loading_users = false;
          vm.user_data = response.data.return;
          vm.pagination_options.total = vm.user_data.total;
          vm.pagination_options.current = vm.user_data.current_page;
          vm.pagination_options.perPage = vm.user_data.per_page;
        })
        .catch((error) => {
          vm.loading_users = false;
          console.log("FINANCE_PRICING_GET_ALL", error);
        });
    },
    searchUser() {
      let vm = this;
      vm.getUserData();
    },
    selectUser(item) {
      let vm = this;
      vm.selected_staff = item;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;
      // margin-right: 10px;
      .control.has-icons-left.is-clearfix {
        @media (max-width: 700px) {
          min-width: 200px;
        }
      }
      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 125px);
    display: flex;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: calc(100% - 450px);
      display: flex;
      @media (max-width: 966px) {
        width: 50%;
      }
      @media (max-width: 700px) {
        width: 55%;
      }
      @media (max-width: 600px) {
        width: 100%;
      }
      .table-widget {
        // height: calc(100% - 60px);
        overflow-y: auto;
        border-radius: 0;
        button.openButton {
          display: none;
          width: fit-content;
          margin: 5px 0 0 5px;
          @media (max-width: 600px) {
            display: flex;
          }
        }
        table {
          width: 100%;
          tr {
            th {
              white-space: nowrap;
            }
            td {
              white-space: nowrap;
              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 450px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #e9e9e9;
      overflow-y: auto;
      button.closeProfileButton {
        display: none;
        position: absolute;
        top: 5px;
        right: 10px;
        @media (max-width: 1200px) {
          display: block;
        }
      }
      @media (max-width: 966px) {
        width: 50%;
      }
      @media (max-width: 700px) {
        width: 45%;
      }
      @media (max-width: 600px) {
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: 0px;
        transition: .5s;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        &.no-data-panel {
          display: none;
        }
      }
      @media (max-width: 485px) {
        width: 90%;
      }
    }
  }

  .wrapper-footer {
    height: 65px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }
}
</style>
